import React from 'react'

function Table(props) {
    return (
        <div className="table-container">
            <table className={props?.class ? props.class+" table custom-table" : "table custom-table"}>
                {props.children}
            </table>    
        </div>
    )
}

export default Table
